import Vue from 'vue'
import { tokenTableName, xbtTokenName } from '@/config'
import { doLogin, doLoginByTempToken, doLogout, getToken, doRefreshToken } from '@/api/user'
import { setItem, getItem, clearAll } from '@/utils/storage'
import { getDeviceInfo } from '@/utils/tool'
import { resetRouter } from '@/router'
import { tokenName } from '@/config'
import dayjs from 'dayjs'

const state = () => ({
  xbtToken: getItem(xbtTokenName),
  accessToken: getItem(tokenTableName),
  refreshToken: getItem('refresh-token'),
  loginRedirect: getItem('login-redirect'),
  permissions: getItem('permissions'),
})

const getters = {
  xbtToken: state => state.xbtToken,
  accessToken: state => state.accessToken,
  loginRedirect: state => state.loginRedirect,
  permissions: state => state.permissions,
}

const mutations = {
  setXbtToken(state, xbtToken) {
    state.xbtToken = xbtToken
    setItem(xbtTokenName, xbtToken)
  },
  async setTokenData(state, data) {
    state.accessToken = data.token
    setItem(tokenTableName, data.token)
    // 保存 refreshToken
    if (data.refreshToken) {
      state.refreshToken = data.refreshToken
      setItem('refresh-token', data.refreshToken)
    }
    state.loginRedirect = data.redirect
    setItem('login-redirect', data.redirect)
  },
  setPermissions(state, permissions) {
    state.permissions = permissions
    setItem('permissions', permissions)
  },
}

const actions = {
  setPermissions({ commit }, permissions) {
    commit('setPermissions', permissions)
  },
  setXbtToken({ commit }, xbtToken) {
    commit('setXbtToken', xbtToken)
  },
  async setAccessToken({ commit }, query) {
    if (query.token) {
      commit('setTokenData', query)
    }
  },
  async refreshAccessToken({ commit, state }) {
    if (!state.refreshToken) {
      return false
    }
    const { deviceId } = await getDeviceInfo()
    try {
      const res = await doRefreshToken(state.refreshToken, deviceId)
      if (res?.success === true && res.data?.token) {
        commit('setTokenData', res.data)
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('刷新授权异常', error)
    }
    return false
  },
  async login({ dispatch }, userInfo) {
    const deviceInfo = await getDeviceInfo()
    userInfo.deviceID = deviceInfo.deviceId
    userInfo.deviceName = deviceInfo.deviceName
    const { data } = await doLogin(userInfo)
    if (data.Require2FA) {
      return data
    }
    dispatch('loginSuccess', data)
    return null
  },
  async loginByTempToken({ dispatch }, userInfo) {
    const deviceInfo = await getDeviceInfo()
    userInfo.deviceID = deviceInfo.deviceId
    userInfo.deviceName = deviceInfo.deviceName
    const { data } = await doLoginByTempToken(userInfo)
    dispatch('loginSuccess', data)
  },
  loginSuccess({ commit }, data) {
    if (data.token) {
      if (!data.redirect) {
        data.redirect = 'home'
      }
      commit('setTokenData', data)
    } else {
      Vue.prototype.$baseMessage(`登录接口异常，未正确返回${tokenName}...`, 'error')
    }
  },
  async logout({ dispatch }) {
    await doLogout()
    await dispatch('resetAccessToken')
    await resetRouter()
  },
  resetAccessToken({ commit }) {
    commit('setPermissions', [])
    commit('setXbtToken', '')
    commit('setTokenData', {})
    clearAll()
  },
}

export default { state, getters, mutations, actions }
